<template>
  <div class="developing-state">
    <empty-state
      :title="title"
      :description="description"
      :icon="icon"
      :icon-size="iconSize">
      <slot></slot>
    </empty-state>
  </div>
</template>

<script>
import EmptyState from "@/components/emptyState";

export default {
  name: "DevelopingState",
  components: {
    EmptyState
  },
  props: {
    title: {
      type: String,
      default: "该功能正在开发中，敬请期待！"
    },
    description: {
      type: String,
      default: "功能上线后会在这里展示相关内容"
    },
    icon: {
      type: String,
      default: "el-icon-cpu"
    },
    iconSize: {
      type: [Number, String],
      default: 56
    }
  }
}
</script>

<style scoped lang="less">
.developing-state {
  box-sizing: border-box;
  width: 100%;
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 56px 24px;
}
</style>
